/**
 * Copyright IBM Corp. 2022, 2026
 */

'use client'

import { AlertBanner, type AlertBannerProps } from 'components/alert-banner'

export default function Banner(props: AlertBannerProps) {
	return <AlertBanner {...props} />
}
